<div class="sports-marquee overflow-hidden">
  <div class="marquee-track">
    <div class="marquee-group">
      <ng-container *ngFor="let sport of sports">
        <span class="sport-text hf text-uppercase f40">{{ sport }}</span>
        <img [src]="logoUrl" class="sport-logo" alt="logo" />
      </ng-container>
    </div>
    <div class="marquee-group" aria-hidden="true">
      <ng-container *ngFor="let sport of sports">
        <span class="sport-text hf text-uppercase f40">{{ sport }}</span>
        <img [src]="logoUrl" class="sport-logo" alt="logo" />
      </ng-container>
    </div>
  </div>
</div>
